export function getTaxonCodeFromId(taxonId: string | null | undefined): string | null {
  if (!taxonId) return null
  const lastIndexOfSlash = taxonId.lastIndexOf('/')
  if (lastIndexOfSlash === -1) return null
  return taxonId.substring(lastIndexOfSlash + 1, taxonId.length)
}
